module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/855a0d7847380c26af17d003a964103f.png";